import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards';

export const usersRoutes: Routes = [
  {
    path: 'users/:userId',
    loadComponent: () =>
      import('./components/profile/user-profile.component').then((m) => m.UserProfileComponent),
    canActivate: [authGuard],
  },
];
